const projectSettingsPath = '/project-settings';
const csvMappingHash = '#xlsx-csv-mapping';
const projectIdParam = 'projectId';

export const buildProjectSettingsHref = (projectId: string): string => {
  const searchParams = new URLSearchParams({ [projectIdParam]: projectId });
  return `${projectSettingsPath}?${searchParams.toString()}`;
};

export const buildProjectCsvMappingSettingsHref = (projectId: string): string => {
  return `${buildProjectSettingsHref(projectId)}${csvMappingHash}`;
};

export const resolveProjectSettingsProjectId = (search: string): string | null => {
  const searchParams = new URLSearchParams(search);
  const projectId = searchParams.get(projectIdParam)?.trim() ?? '';
  return projectId.length > 0 ? projectId : null;
};
